import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { ColorStyle } from "src/utils/Colors";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { Route } from "src/config/routes";
import { useLocation } from "react-router-dom";
import styles from "./InvoiceBanner.module.css";

import { INVOICE_STATE } from "src/stores/krediflow/InvoiceEnums";

const InvoiceBannerBase = () => {
    const { t } = useTranslation();
    const { invoiceStore } = useContext(RootStoreContext);
    const location = useLocation();

    const isCreditorRoute = location.pathname.includes(`${Route.creditor}/`);
    const isInvoiceStateCancelled = invoiceStore.currentInvoice?.state === INVOICE_STATE.CANCELLED;
    const isInvoiceStatePaid = invoiceStore.currentInvoice?.state === INVOICE_STATE.PAID;

    if (!(isCreditorRoute && (isInvoiceStateCancelled || isInvoiceStatePaid))) {
        return null;
    }

    return (
        <div className={`${styles.CancelledInvoiceBanner} container-fluid`}>
            <UI.Row>
                <UI.Col xl={9} sm={9} className="d-flex align-items-center mb-4 mb-lg-0">
                    <UI.Icon
                        className={`${styles.CancelledInvoiceBannerInfoIcon}`}
                        icon={UI.SVGIcon.Information}
                        color={ColorStyle("white")}
                    />
                    <div className={`${styles.CancelledInvoiceBannerText}`}>
                        {/* {t("screens.kredi_flow.cancelled_invoice_banner")} */}
                        {t("screens.kredi_flow.invoice_banner.edit_disabled_message", {
                            state: isInvoiceStateCancelled
                                ? t("screens.kredi_flow.invoice_banner.edit_disabled_archived")
                                : isInvoiceStatePaid
                                ? t("screens.kredi_flow.invoice_banner.edit_disabled_paid")
                                : ""
                        })}
                    </div>
                </UI.Col>
            </UI.Row>
        </div>
    );
};

export const InvoiceBanner = Sentry.withProfiler(observer(InvoiceBannerBase));
